
export const common = {
  // Navigation
  'nav.slogan': 'An AI verdict on your business idea — before you build',
  'nav.features': 'Features',
  'nav.howItWorks': 'How it works',
  'nav.pricing': 'Pricing',
  'nav.faq': 'FAQ',
  'nav.aboutUs': 'About Us',
  'nav.getStarted': 'Get Started',

  // About Us Section
  'aboutUs.badge': "About us",
  'aboutUs.title': "We argue with your idea so you don't argue with reality later.",
  'aboutUs.line1': "Most ideas don't fail because the founder lacked talent.",
  'aboutUs.line2': "They fail because no one told them the truth early — when changing course was still cheap.",
  'aboutUs.paragraph1':
    "IdeaVerdict closes that gap. We pressure-test your idea against the market signals that actually decide outcomes: demand, competition, capital, time, scalability. We don't trade in motivation. We trade in market evidence.",
  'aboutUs.belief1a': "We don't trade in motivation.",
  'aboutUs.belief1b': "We trade in market evidence.",
  'aboutUs.belief2a': "We don't sell hope.",
  'aboutUs.belief2b': "We sell a clear read on what your idea is up against.",
  'aboutUs.mission1': "Our job isn't to make your idea look good.",
  'aboutUs.mission2': "Our job is to tell you if it actually is.",
  'aboutUs.analysis':
    "We score your idea on seven things that decide whether it survives: demand, competition, startup capital, time to revenue, profit potential, scalability, and risk. No emotion. No optimism. Just analysis.",
  'aboutUs.failure1': "Most businesses fail.",
  'aboutUs.failure2': "Not because the people behind them were incompetent —",
  'aboutUs.failure3': "but because no one pushed back hard enough, early enough.",
  'aboutUs.clarity': "We exist to push back.",
  'aboutUs.value1': "Direct.",
  'aboutUs.value2': "Honest.",
  'aboutUs.value3': "Fast.",
  'aboutUs.confirm': "If your idea has substance, we'll back it.",
  'aboutUs.deny': "If it doesn't, we'll say it to your face.",
  'aboutUs.noApplause': "No applause.",
  'aboutUs.noSugarcoating': "No cheerleading.",
  'aboutUs.noTheater': "No theatre.",
  'aboutUs.noHype': "Just the verdict.",
  // Hero Section
  'hero.badge': 'AI idea verdict · in under 60 seconds',
  'hero.title1': 'Stop guessing.',
  'hero.title2': 'Start with a verdict.',
  'hero.subtitle': 'IdeaVerdict runs your business idea through seven hard checks',
  'hero.subtitleLine2': 'and gives you a straight answer — build it, fix it, or drop it.',
  'hero.cta': 'Get my verdict',
  'hero.ctaSecondary': 'See how it works',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'Credits per analysis',
  'hero.stat2Value': '7',
  'hero.stat2Label': 'Verdict dimensions',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'Honest & private',

  // Features Section
  'features.title1': 'Made for',
  'features.title2': 'founders',
  'features.title3': 'who want signal, not noise.',
  'features.bullet1.title': 'A second opinion you can trust',
  'features.bullet1.description':
    'Every analysis is graded Strong, Mixed, or Weak — with the reasoning behind it. No applause, no sugar-coating. Just what the market is likely to say back to you.',
  'features.bullet2.title': 'Scored on what the market cares about',
  'features.bullet2.description':
    'Real demand. Competition. Capital needed. Time to revenue. Scalability. The things VCs look at first — applied to your idea before you\'ve built anything.',
  'features.bullet3.title': 'From idea to developer-ready plan',
  'features.bullet3.description':
    'Builder mode converts a green-lit verdict into a structured brief: user flows, core features, technical notes. You skip the whiteboard and hand it straight to an engineer.',

  // How It Works
  'howItWorks.title': 'How it works',
  'howItWorks.subtitle': 'Four steps. About ten minutes total.',
  'howItWorks.step1Title': 'Pick your depth',
  'howItWorks.step1Desc': 'Starter for quick checks. Pro for full analysis. Builder for ship-ready briefs. Pick what matches your stage.',
  'howItWorks.step2Title': 'Tell the AI your idea',
  'howItWorks.step2Desc': 'One paragraph. The clearer you write it, the sharper the verdict you get back. Each analysis costs 30 credits.',
  'howItWorks.step3Title': 'Read the verdict',
  'howItWorks.step3Desc': 'Strong, Mixed, or Weak — across seven dimensions. Plus a score out of 100 you can argue with.',
  'howItWorks.step4Title': "Decide what's next",
  'howItWorks.step4Desc': "Build it. Sharpen it. Pivot. Drop it. You'll know which to do — and why.",

  // Pricing
  'pricing.title': 'Pricing',
  'pricing.subtitle': 'Choose the plan that fits your review depth.',
  'pricing.monthly': 'Monthly',
  'pricing.yearly': 'Yearly',
  'pricing.yearlyDiscount': 'Annual subscription:',
  'pricing.yearlyDiscountValue': '-20% discount',
  'pricing.perMonth': 'per month',
  'pricing.selectPlan': 'Select Plan',
  'pricing.mostPopular': 'Most Popular',
  'pricing.footer':
    'All prices in CHF. Credits are only deducted for successful AI responses.',

  
  // Pricing Features
  'pricing.feature1': 'Free Chat (no form)',
  'pricing.feature2': 'Market logic & honest rating',
  'pricing.feature3': 'Persistent chat history',
  'pricing.feature4': 'Multiple parallel chat sessions',
  'pricing.feature5': 'Fully multilingual',
  'pricing.feature6': 'Credit-based usage',
  'pricing.feature7': 'Monthly reset',
  'pricing.feature8': 'Market analysis',
  'pricing.feature9': 'Summary',
  'pricing.feature10': 'Strengths',
  'pricing.feature11': 'Weaknesses',
  'pricing.feature12': 'Opportunities',
  'pricing.feature13': 'Risks',
  'pricing.feature14': 'Recommendations',
  'pricing.feature15': 'Download PDF',
  'pricing.feature16': 'No developer briefings',
  'pricing.feature17': 'Builder mode: Developer briefings',
  'pricing.feature18': 'Structured summary',

  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.price': '39.90',
  'pricing.starter.description': 'Access to AI niche chatbot',
  'pricing.starter.credits': '2,500 Credits per month',
  'pricing.starter.feature1': 'Generate niche idea',
  'pricing.starter.feature2': 'Refine niche',
  'pricing.starter.feature3': 'Market reality check',
  'pricing.starter.feature4': 'Competition assessment',
  'pricing.starter.feature5': 'Time assessment',
  'pricing.starter.feature6': 'Honest verdict',
  'pricing.starter.feature7': 'Private sessions',
  'pricing.starter.feature8': 'History & export',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.price': '59.90',
  'pricing.pro.description': 'Access to AI niche chatbot',
  'pricing.pro.credits': '5,000 Credits per month',
  'pricing.pro.feature1': 'All Starter features',
  'pricing.pro.feature2': 'More credits for intensive review',
  'pricing.pro.feature3': 'Improvement suggestions',
  'pricing.pro.feature4': 'Alternative niches',
  'pricing.pro.feature5': 'Detailed market analysis',
  'pricing.pro.feature6': 'Priority support',
  'pricing.pro.feature7': 'Advanced filters',
  'pricing.pro.feature8': 'Session favorites',

  // Builder Plan
  'pricing.builder.name': "Builder",
  'pricing.builder.price': '199',
  'pricing.builder.description': "All features + Builder mode",
  'pricing.builder.credits': "10,000 Credits per month",
  'pricing.builder.feature1': 'All Pro features',
  'pricing.builder.feature2': 'Unlimited AI requests',
  'pricing.builder.feature3': 'Builder mode: Developer briefings',
  'pricing.builder.feature4': 'Structured project overview',
  'pricing.builder.feature5': 'User flows & core features',
  'pricing.builder.feature6': 'Technical notes',
  'pricing.builder.feature7': 'Define non-goals',
  'pricing.builder.feature8': 'Fair use rate limit',
  'pricing.builder.limitNote': 'Fair use limit',
  'pricing.monthlyReset': 'Monthly reset',

  // Modal
  'pricing.modal.selected': 'selected',
  'pricing.modal.comingSoon':
    'Registration and payment processing will be available soon.',
  'pricing.modal.patience':
    'We are working to provide you with a secure and seamless experience. Please be patient.',
  'pricing.modal.understood': 'Understood',

  // FAQ
  'faq.title': 'FAQ',
  'faq.subtitle': 'Direct answers, no marketing.',
  'faq.q1': "What does IdeaVerdict actually do?",
  'faq.a1': "It scores your business idea on the seven things that decide whether it survives a market: demand, competition, startup capital, time to revenue, profit potential, scalability, and risk.\nYou get a verdict, a number, and the reasoning behind both.",
  'faq.q2': "Can you generate ideas, or only critique mine?",
  'faq.a2': "Both.\nTell us about your skills, capital, and time — we'll surface niches with real market gaps.\nOr paste your own and we'll dissect it.",
  'faq.q3': "How are you different from ChatGPT?",
  'faq.a3': "ChatGPT tries to be helpful.\nWe try to be accurate.\nWe're tuned to push back when the math doesn't work — instead of finding reasons your idea is great.",
  'faq.q4': "Does this guarantee my idea will succeed?",
  'faq.a4': "No tool guarantees that.\nWe help you avoid obviously-bad bets and sharpen the ones with a fighting chance.\nRisk doesn't disappear — but you walk in with your eyes open.",
  'faq.q5': "Who is this for?",
  'faq.a5': "Founders before launch.\nOperators before a side bet.\nBuilders before the weekend project.\nInvestors before the cheque.\n\nAnyone who wants clarity before commitment.",
  'faq.q6': "What if I just want someone to tell me my idea is great?",
  'faq.a6': "Then we're the wrong tool.\nWe give an honest read, not reassurance.",
  'faq.q7': "How honest is the analysis really?",
  'faq.a7': "As honest as the data allows.\nWe don't soften a weak verdict to protect feelings.\nIf your idea has a problem, we'll say it — and we'll say where it lives.",
  'faq.q8': "Does this replace real market research?",
  'faq.a8': "No.\nIt's a fast strategic check before you commit time and money — not a 50-page report.\nUse us to decide whether the deeper research is worth doing.",
  'faq.q9': "What does Builder mode add?",
  'faq.a9': "Once a verdict is positive, Builder mode turns it into a developer brief: user flows, core features, monetization model, technical considerations.\nThe thing you'd hand to your first engineer.",
  'faq.q10': "Why so direct?",
  'faq.a10': "Because building the wrong thing costs months.\nAn honest verdict costs minutes.\n\nWe choose the minutes.",
  // Footer
  'footer.description':
    "IdeaVerdict isn't here to make you feel good about your idea. It's here to help you decide whether to bet on it.",
  'footer.product': 'Product',
  'footer.aiAssistant': 'AI Assistant',
  'footer.howItWorks': 'How it works',
  'footer.pricing': 'Pricing',
  'footer.faq': 'FAQ',
  'footer.legal': 'Legal',
  'footer.privacy': 'Privacy',
  'footer.terms': 'Terms',
  'footer.imprint': 'Imprint',
  'footer.support': 'Support',
  'footer.contact': 'Contact',
  'footer.documentation': 'Documentation',
  'footer.copyright': '© 2026 IdeaVerdict. All rights reserved.',

  // AI Assistant
  'aiAssistant.title': 'AI Niche Assistant',
  'aiAssistant.subtitle': 'Ask about niches',
  'aiAssistant.welcomeMessage':
    'Hi! Describe your idea or ask me about a niche. I will give you a clear and honest evaluation.',
  'aiAssistant.demoResponse':
    'This is a demo. To get real AI evaluations, please register and choose a plan.',
  'aiAssistant.placeholder': 'Describe your idea...',

  // Header & Sidebar
  'dashboard.header.title': 'Dashboard',
  'dashboard.header.aiAssistant': 'Your AI Assistant',
  'header.logout': 'Sign Out',
  'dashboard.sidebar.overview': 'Overview',
  'dashboard.sidebar.aiChat': 'AI Assistant',
  'dashboard.sidebar.newAnalysis': 'AI Assistant',
  'dashboard.sidebar.history': 'History',
  'dashboard.sidebar.credits': 'Credits',
  'dashboard.sidebar.settings': 'Settings',

  // Dashboard Overview
  'dashboard.overview.welcome': 'Welcome back, {{name}}',
  'dashboard.overview.subtitle':
    'Here is a quick overview of your activity',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'Credits remaining',
  'dashboard.stats.totalAnalyses': 'Total analyses',
  'dashboard.stats.goodRatings': 'Positive ratings',
  'dashboard.stats.nextReset': 'Next reset in',
  'dashboard.stats.days': 'days',

  // Quick Actions
  'dashboard.quickActions.title': 'Quick actions',
  'dashboard.quickActions.checkNewIdea': 'Check an idea',
  'dashboard.quickActions.checkNewIdeaDesc':
    'Analyze an existing business idea',
  'dashboard.quickActions.generateIdea': 'Generate an idea',
  'dashboard.quickActions.generateIdeaDesc':
    'Find a new profitable niche',
  'dashboard.quickActions.builderBriefing': 'Builder briefing',
  'dashboard.quickActions.builderBriefingDesc':
    'Turn an idea into a developer-ready briefing',
  'dashboard.quickActions.premiumOnly': 'Builder only',

  // Chat Header
  'chat.title': 'AI Niche Assistant',
  'chat.subtitle':
    'Ask questions about niches. I evaluate critically and honestly.',
  'chat.creditsLabel': 'Credits',

  // Chat Welcome
  'chat.welcomeTitle': 'Welcome to the AI Niche Assistant',
  'chat.welcomeDesc':
    'Describe your idea or ask about a niche. I will evaluate it honestly: Good, Average or Bad.',
  'chat.aiWelcome':
    'Hi! Describe your idea or ask me about a niche. I will give you a clear and honest evaluation.',

  // Chat Suggestions
  'chat.suggestion1': 'I want to build a SaaS tool for freelancers to manage invoices. Is this a good niche?',
  'chat.suggestion2': 'Find me a low-competition online business I can start with $500 and no coding skills.',
  'chat.suggestion3': 'Evaluate this: an AI-powered meal planning app for busy parents with dietary restrictions.',
  'chat.suggestion4': 'I want to sell digital templates on Etsy for small business owners. Analyze this niche honestly.',

  // Chat Actions
  'chat.newConversation': 'New conversation',
  'chat.today': 'Today',
  'chat.yesterday': 'Yesterday',
  'chat.thisWeek': 'This week',
  'chat.thisMonth': 'This month',
  'chat.older': 'Older',
  'chat.messages': 'messages',
  'chat.renameConversation': 'Rename',
  'chat.deleteConversation': 'Delete',
  'chat.cancel': 'Cancel',
  'chat.rename': 'Rename',
  'chat.delete': 'Delete',
  'chat.favorite': 'Add favorite',
  'chat.unfavorite': 'Remove favorite',
  'chat.searchSessions': 'Search conversations...',
  'chat.noResults': 'No results found',
  'chat.noSessions': 'No conversations yet',
  'chat.enterNewName': 'Enter new name...',
  'chat.deleteConfirmMessage':
    'Are you sure you want to delete this conversation? This action cannot be undone.',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'Type your question… (costs 30 credits)',
  'chat.send': 'Send',
  'chat.voice': 'Speak',
  'chat.listeningPlaceholder': 'I\'m listening... Speak now.',
  'chat.stopListening': 'Stop listening',
  'chat.recording': 'Recording...',
  'chat.speechNotSupported': 'Your browser does not support voice recognition.',
  'chat.microphonePermissionDenied': 'Microphone access denied. Please allow access in browser settings.',
  'chat.errorNotEnoughCredits':
    'Not enough credits. Please upgrade your plan or wait for the next reset.',
  'chat.errorAiFailed': 'AI response failed. No credits were deducted.',
  'chat.errorRateLimit': 'Too many requests. Please wait a moment.',
  'chat.creditsPerQuestion': 'Credits/question',
  'chat.notEnoughCreditsTitle': 'Not enough credits',
  'chat.notEnoughCreditsDesc': 'You need at least {{cost}} credits per question.',
  'chat.creditsRunningLow': 'Credits running low',
  'chat.questionsRemaining': '{{count}} questions remaining.',
  'chat.noCreditsModalTitle': 'Not enough credits',
  'chat.noCreditsModalDesc': 'You need at least <1>{{cost}} credits</1> per question. Your current balance: <2>{{balance}} credits</2>',
  'chat.currentPlan': 'Current plan',
  'chat.close': 'Close',
  'chat.upgrade': 'Upgrade',

  // Ratings
  'rating.good': 'Good',
  'rating.medium': 'Average',
  'rating.bad': 'Bad',

  // Auth Page
  'auth.branding.headline1': 'Not every idea is good.',
  'auth.branding.headline2': 'We tell you honestly.',
  'auth.branding.subtitle':
    'A decision AI for business niches. Clear. Critical. No sugarcoating.',
  'auth.benefits.privacy.title': '100% Private',
  'auth.benefits.privacy.desc':
    'Your ideas stay completely private and secure.',
  'auth.benefits.honest.title': 'Honest AI',
  'auth.benefits.honest.desc':
    'No sugarcoating – just clear, critical feedback.',
  'auth.benefits.fast.title': 'Fast Results',
  'auth.benefits.fast.desc': 'Get clarity about your niche in minutes.',
  'auth.trust.users': 'Active Users',
  'auth.trust.ideas': 'Ideas Analyzed',
  'auth.trust.rating': 'User Rating',
  'auth.login.title': 'Login',
  'auth.login.headline': 'Welcome back',
  'auth.login.subtitle': 'Sign in to continue your journey.',
  'auth.login.forgotPassword': 'Forgot password?',
  'auth.login.submit': 'Sign In',
  'auth.login.noAccount': 'No account yet?',
  'auth.login.signUp': 'Sign up',
  'auth.register.title': 'Register',
  'auth.register.headline': 'Create your account',
  'auth.register.subtitle':
    'Start analyzing your business ideas today.',
  'auth.register.submit': 'Create Account',
  'auth.register.hasAccount': 'Already have an account?',
  'auth.register.signIn': 'Sign in',
  'auth.fields.name': 'Full Name',
  'auth.fields.email': 'Email Address',
  'auth.fields.password': 'Password',
  'auth.fields.confirmPassword': 'Confirm Password',
  'auth.fields.selectPlan': 'Select your plan',
  'auth.fields.testCode': 'Login and test for free',
  'auth.placeholders.name': 'Enter your name',
  'auth.placeholders.email': 'Enter your email',
  'auth.placeholders.password': 'Enter your password',
  'auth.placeholders.confirmPassword': 'Confirm your password',
  'auth.placeholders.testCode': 'Enter test code',
  'auth.terms.accept': 'I accept the',
  'auth.terms.terms': 'Terms & Conditions',
  'auth.privacy.accept': 'I accept the',
  'auth.privacy.policy': 'Privacy Policy',
  'auth.errors.nameRequired': 'Name is required',
  'auth.errors.emailRequired': 'Email is required',
  'auth.errors.emailInvalid': 'Please enter a valid email',
  'auth.errors.passwordRequired': 'Password is required',
  'auth.errors.passwordLength': 'Password must be at least 8 characters',
  'auth.errors.passwordMismatch': 'Passwords do not match',
  'auth.errors.invalidCode': 'Invalid or expired code',
  'auth.errors.registrationCodeOnly': 'This code is for registration only',
  'auth.errors.verificationFailed': 'Error verifying code. Please try again.',
  'auth.loading': 'Please wait...',
  'auth.or': 'or continue with',
  'auth.social.google': 'Continue with Google',
  'auth.social.apple': 'Continue with Apple',
  'auth.actions.verify': 'Verify',
  'auth.testCode.activated': 'Test code activated!',
  'auth.testCode.days': 'days',
  'auth.testCode.months': 'months',
  'auth.testCode.freeAccess': 'free access',
  'auth.testCode.credits': 'credits',

  // Email Verification
  'auth.verification.title': 'Verify Email',
  'auth.verification.headline': 'Check your inbox',
  'auth.verification.subtitle': 'We sent a verification code to:',
  'auth.verification.codeLabel': 'Verification Code',
  'auth.verification.codePlaceholder': 'Enter 6-digit code',
  'auth.verification.submit': 'Verify Email',
  'auth.verification.resend': 'Resend code',
  'auth.verification.resendIn': 'Resend in',
  'auth.verification.seconds': 'seconds',
  'auth.verification.success': 'Email verified successfully!',
  'auth.verification.error': 'Invalid code. Please try again.',
  'auth.verification.expired': 'Code expired. Please request a new one.',
  'auth.verification.sent': 'New code sent!',
  'auth.verification.checkSpam':
    "Didn't receive it? Check your spam folder.",

  // Forgot Password
  'auth.forgot.title': 'Forgot Password',
  'auth.forgot.headline': 'Reset your password',
  'auth.forgot.subtitle':
    "Enter your email address and we'll send you a reset link.",
  'auth.forgot.submit': 'Send Reset Link',
  'auth.forgot.backToLogin': 'Back to login',
  'auth.forgot.success': 'Email sent!',
  'auth.forgot.successMessage':
    "We've sent you an email with instructions to reset your password.",
  'auth.forgot.checkInbox': 'Check your inbox',

  // Reset Password
  'auth.reset.title': 'New Password',
  'auth.reset.headline': 'Set new password',
  'auth.reset.subtitle': 'Enter your new password.',
  'auth.reset.newPassword': 'New Password',
  'auth.reset.confirmNewPassword': 'Confirm New Password',
  'auth.reset.submit': 'Change Password',
  'auth.reset.success': 'Password changed successfully!',
  'auth.reset.successMessage':
    'You can now sign in with your new password.',
  'auth.reset.loginNow': 'Sign in now',

  // Legal Pages
  'legal.backToAuth': 'Back to login',
  'legal.allRightsReserved': 'All rights reserved.',

  // Terms Page
  'legal.terms.title': 'Terms and Conditions',
  'legal.terms.lastUpdated': 'Last updated',
  'legal.terms.section1.title': '1. Scope',
  'legal.terms.section1.content':
    'These Terms and Conditions apply to all contracts between NicheFinder (hereinafter "Provider") and the user (hereinafter "Customer") regarding the use of the AI-powered niche analysis platform.',
  'legal.terms.section2.title': '2. Service Description',
  'legal.terms.section2.content':
    'The Provider offers an AI-based platform that analyzes and evaluates business ideas and niches. Services include:',
  'legal.terms.section2.item1': 'AI-powered analysis of business ideas',
  'legal.terms.section2.item2': 'Evaluation of market potential and competition',
  'legal.terms.section2.item3': 'Generation of niche suggestions',
  'legal.terms.section2.item4': 'Creation of developer briefings (Builder package)',
  'legal.terms.section3.title': '3. Contract Conclusion and Registration',
  'legal.terms.section3.content':
    'The contract is concluded through registration on the platform and selection of a package. The customer confirms:',
  'legal.terms.section3.item1': 'Being of legal age and fully legally competent',
  'legal.terms.section3.item2': 'Providing truthful information during registration',
  'legal.terms.section3.item3': 'Secure storage of access credentials',
  'legal.terms.section4.title': '4. Credits and Billing',
  'legal.terms.section4.content':
    'The use of AI features is based on a credit system. Each AI query costs 30 credits. Credits are only deducted upon successful response. Unused credits expire at the end of the billing period and are not refunded.',
  'legal.terms.section5.title': '5. Disclaimer',
  'legal.terms.section5.content':
    'AI evaluations serve solely as decision-making aids and do not guarantee business success. The Provider is not liable for decisions made based on AI analyses. Liability for intent and gross negligence remains unaffected.',
  'legal.terms.section6.title': '6. Data Protection and Confidentiality',
  'legal.terms.section6.content':
    'All submitted business ideas are treated confidentially and not shared with third parties. Processing of personal data is carried out in accordance with our Privacy Policy and applicable data protection laws.',
  'legal.terms.section7.title': '7. Termination',
  'legal.terms.section7.content':
    'The customer may cancel their subscription at any time at the end of the current billing period. In case of violations of these Terms, the Provider reserves the right to block access to the platform.',
  'legal.terms.section8.title': '8. Final Provisions',
  'legal.terms.section8.content':
    'Swiss law applies. Place of jurisdiction is Zurich, Switzerland. Should individual provisions of these Terms be invalid, the validity of the remaining provisions remains unaffected.',
  'legal.terms.contact.title': 'Questions about the Terms?',
  'legal.terms.contact.content':
    'If you have questions about these Terms and Conditions, please contact us at:',

  // Privacy Page
  'legal.privacy.title': 'Privacy Policy',
  'legal.privacy.section1.title': '1. Data Controller',
  'legal.privacy.section1.content':
    'The data controller for this website is NicheFinder, Zurich, Switzerland. We take the protection of your personal data very seriously and treat your personal data confidentially and in accordance with statutory data protection regulations.',
  'legal.privacy.section2.title': '2. Data Collected',
  'legal.privacy.section2.content':
    'We collect and process the following personal data:',
  'legal.privacy.section2.item1':
    'Registration data: Name, email address, password (encrypted)',
  'legal.privacy.section2.item2':
    'Usage data: IP address, browser type, access times',
  'legal.privacy.section2.item3':
    'Business ideas and niche queries (stored anonymously)',
  'legal.privacy.section2.item4':
    'Payment information (via secure third-party providers)',
  'legal.privacy.section3.title': '3. Purpose of Data Processing',
  'legal.privacy.section3.content':
    'Your data is used for the following purposes:',
  'legal.privacy.section3.item1':
    'Provision and improvement of our AI services',
  'legal.privacy.section3.item2':
    'Account management and authentication',
  'legal.privacy.section3.item3':
    'Billing and payment processing',
  'legal.privacy.section4.title': '4. Data Security',
  'legal.privacy.section4.content':
    'We implement technical and organizational security measures to protect your data against manipulation, loss, destruction, or unauthorized access. All data transfers are encrypted via SSL/TLS.',
  'legal.privacy.section5.title': '5. Confidentiality of Your Business Ideas',
  'legal.privacy.section5.content':
    'Your submitted business ideas and niche queries are treated strictly confidentially. They are not shared with third parties, not used for training purposes, and can be completely deleted upon request. Your ideas belong to you.',
  'legal.privacy.section6.title': '6. Your Rights',
  'legal.privacy.section6.content':
    'You have the following rights regarding your personal data:',
  'legal.privacy.section6.item1': 'Right to access stored data',
  'legal.privacy.section6.item2': 'Right to rectification of inaccurate data',
  'legal.privacy.section6.item3': 'Right to deletion of your data',
  'legal.privacy.section6.item4': 'Right to data portability',
  'legal.privacy.section7.title': '7. Cookies',
  'legal.privacy.section7.content':
    'Our website only uses technically necessary cookies for authentication and session management. We do not use tracking cookies or third-party analytics tools without your explicit consent.',
  'legal.privacy.section8.title': '8. Changes to this Privacy Policy',
  'legal.privacy.section8.content':
    'We reserve the right to adapt this privacy policy to comply with changed legal requirements or when changes to the service occur. The current version can always be found on this page.',
  'legal.privacy.contact.title': 'Questions about Privacy?',
  'legal.privacy.contact.content':
    'If you have questions about the processing of your personal data, please contact us at:',

  'auth.passwordStrength.label': 'Password strength',
  'auth.passwordStrength.weak': 'Weak',
  'auth.passwordStrength.medium': 'Medium',
  'auth.passwordStrength.strong': 'Strong',
  'auth.passwordStrength.veryStrong': 'Very strong',
  'auth.passwordStrength.minLength': 'Min. 8 characters',
  'auth.passwordStrength.uppercase': 'Uppercase letter',
  'auth.passwordStrength.number': 'Number',
  'auth.passwordStrength.special': 'Special character',

  trial: {
    subtitle: 'Free Trial',
    upgrade: 'Upgrade Now',
    creditsRemaining: 'credits remaining',
    inputHint: 'Trial version - No conversation history available',
    banner: {
      title: '7-Day Trial Active',
      remaining: '{{days}} days remaining',
      credits: 'credits available',
      upgradeNow: 'Upgrade Now',
    },
    welcome: {
      title: 'Welcome to the Free Trial!',
      desc: 'Test our AI assistant for 7 days free with 100 credits. Ask questions and discover the possibilities!',
    },
    info: {
      title: 'Trial Limitations',
      credits: '100 credits for 7 days',
      noHistory: 'No conversation history',
      noSettings: 'Limited features',
      upgrade: 'Upgrade for full features',
    },
  },

  // ─── Settings Page ────────────────────────────────────────────────────────────
  'settings.title': 'Settings',
  'settings.subtitle': 'Manage your account and preferences',
  'settings.backToOverview': 'Back to overview',
  'settings.subscriptionLink': 'Subscription & Billing',
  'settings.saved': 'Changes saved successfully',
  'settings.changesSaved': 'Changes saved',
  'settings.saveChanges': 'Save changes',
  'settings.dataExported': 'Data exported successfully',

  // Tabs
  'settings.tabs.profile': 'Profile',
  'settings.tabs.preferences': 'Preferences',
  'settings.tabs.notifications': 'Notifications',
  'settings.tabs.account': 'Account & Plan',

  // Profile
  'settings.profile.changePhoto': 'Change photo',
  'settings.profile.photoHint': 'JPG, PNG or GIF (max. 2MB)',
  'settings.profile.uploading': 'Uploading...',
  'settings.profile.photoUpdated': 'Profile photo updated!',
  'settings.profile.name': 'Name',
  'settings.profile.email': 'Email',
  'settings.profile.phone': 'Phone',
  'settings.profile.changePassword': 'Change password',
  'settings.profile.currentPassword': 'Current password',
  'settings.profile.newPassword': 'New password',
  'settings.profile.confirmPassword': 'Confirm password',

  // Preferences
  'settings.preferences.language': 'Language',
  'settings.preferences.chooseLanguage': 'Choose language',
  'settings.preferences.timezone': 'Timezone',
  'settings.preferences.currency': 'Currency',

  // Notifications
  'settings.notifications.emailTitle': 'Email Notifications',
  'settings.notifications.email.analysis': 'Analysis complete',
  'settings.notifications.email.analysisDesc': 'Receive an email when your analysis is ready',
  'settings.notifications.email.credits': 'Credit updates',
  'settings.notifications.email.creditsDesc': 'Notifications about credits and resets',
  'settings.notifications.email.billing': 'Invoices & Payments',
  'settings.notifications.email.billingDesc': 'Notifications about invoices and plan changes',
  'settings.notifications.email.newsletter': 'Newsletter',
  'settings.notifications.email.newsletterDesc': 'Tips, updates and new features',
  'settings.notifications.pushTitle': 'Push Notifications',
  'settings.notifications.push.analysis': 'Analysis complete',
  'settings.notifications.push.analysisDesc': 'Browser notification when analysis is ready',
  'settings.notifications.push.credits': 'Credit warnings',
  'settings.notifications.push.creditsDesc': 'Warning when credit balance is low',

  // Account
  'settings.account.currentSubscription': 'Current Subscription',
  'settings.account.plan': 'Plan',
  'settings.account.price': 'Price',
  'settings.account.nextBilling': 'Next billing',
  'settings.account.manageSubscription': 'Manage subscription & payments',
  'settings.account.dataPrivacy': 'Data & Privacy',
  'settings.account.exportData': 'Export data',
  'settings.account.deleteAccount': 'Delete account',

  // Delete Modal
  'settings.deleteModal.title': 'Delete account?',
  'settings.deleteModal.subtitle': 'All data will be permanently deleted.',
  'settings.deleteModal.warning1': 'All analyses and data will be deleted',
  'settings.deleteModal.warning2': 'Active subscription will be cancelled immediately',
  'settings.deleteModal.warning3': 'No refund possible',
  'settings.deleteModal.confirmLabel': 'Type "{{word}}" to confirm *',
  'settings.deleteModal.cancel': 'Cancel',
  'settings.deleteModal.confirm': 'Delete account',

  // ─── Subscription & Billing ─────────────────────────────
  'sub.backToOverview': 'Back to overview',
  'sub.settings': 'Settings',
  'sub.title': 'Subscription & Billing',
  'sub.subtitle': 'Manage your subscription, payment methods and invoices',
  'sub.tab.overview': 'Overview',
  'sub.tab.payment': 'Payment Methods',
  'sub.tab.billing': 'Billing Address',
  'sub.tab.history': 'Payment History',
  'sub.memberSince': 'Member since',
  'sub.perMonth': 'per month',
  'sub.baseCHF': '(CHF {{amount}} base)',
  'sub.nextBilling': 'Next billing',
  'sub.creditsUsed': 'Credits used',
  'sub.paymentMethod': 'Payment method',
  'sub.creditUsage': 'Credit usage',
  'sub.changePlan': 'Change plan',
  'sub.manageBilling': 'Manage billing',
  'credits.topup.buyMore': 'Buy more credits',
  'sub.reactivate': 'Reactivate',
  'sub.cancelSub': 'Cancel subscription',
  'sub.manageCards': 'Manage cards',
  'sub.downloadInvoices': 'Download invoices',
  'sub.invoicesAvailable': '{{count}} invoices available as PDF',
  'sub.accountSettings': 'Account Settings',
  'sub.profileNotifications': 'Profile, notifications & more',
  // Prices in EUR info
  'sub.eurInfo': 'Prices shown in',
  'sub.eurLabel': 'Euro',
  'sub.eurRate': 'Rate:',
  'sub.currentRate': 'Current rate',
  // Payment Methods
  'sub.savedCards': 'Saved Cards',
  'sub.newCard': 'New Card',
  'sub.default': 'Default',
  'sub.setDefault': 'Set as default',
  'sub.validUntil': 'Valid until',
  'sub.noCards': 'No cards saved',
  'sub.addFirstCard': 'Add first card',
  'sub.securePayments': 'Secure Payments',
  'sub.securePaymentsDesc': 'All payment data is transmitted encrypted and stored securely with our payment provider. We do not store complete card numbers.',
  // Billing Address
  'sub.billingAddress': 'Billing Address',
  'sub.edit': 'Edit',
  'sub.name': 'Name',
  'sub.streetAddress': 'Street & Number',
  'sub.zip': 'ZIP Code',
  'sub.city': 'City',
  'sub.country': 'Country',
  'sub.address': 'Address',
  'sub.save': 'Save',
  'sub.cancel': 'Cancel',
  'sub.country.switzerland': 'Switzerland',
  'sub.country.germany': 'Germany',
  'sub.country.austria': 'Austria',
  'sub.country.netherlands': 'Netherlands',
  'sub.country.belgium': 'Belgium',
  // Payment History
  'sub.paymentHistory': 'Payment History',
  'sub.allInvoicesPDF': 'Download all invoices as PDF with logo',
  'sub.downloadAll': 'Download all',
  'sub.eurInvoiceNote': 'Invoices are always issued in CHF. Displayed EUR amounts are for reference only.',
  'sub.date': 'Date',
  'sub.description': 'Description',
  'sub.net': 'Net',
  'sub.vat': 'VAT',
  'sub.total': 'Total',
  'sub.status': 'Status',
  'sub.pdf': 'PDF',
  'sub.invoices': 'invoices',
  'sub.totalAmount': 'Total amount',
  // Change Plan Modal
  'sub.changePlanTitle': 'Change Plan',
  'sub.current': 'Current',
  'sub.month': '/month',
  'sub.showLess': 'Show less',
  'sub.showMore': '+{{count}} more',
  'sub.switchPlan': 'Switch plan',
  'sub.eurPriceNote': 'Prices shown in EUR ({{note}}). Billing is in CHF.',
  // Cancel Modal
  'sub.cancelTitle': 'Really cancel subscription?',
  'sub.cancelIrreversible': 'This action cannot be undone.',
  'sub.cancelWarning1': 'All remaining credits will expire',
  'sub.cancelWarning2': 'Downgrade to Free Plan',
  'sub.cancelWarning3': 'Loss of all premium features',
  'sub.pauseInstead': 'Alternatively: Pause subscription?',
  'sub.pauseDesc': 'Pause your subscription instead and keep your data.',
  'sub.preferPause': 'Prefer to pause',
  'sub.cancelReason': 'Cancellation reason',
  'sub.selectReason': 'Please select...',
  'sub.reason.tooExpensive': 'Too expensive',
  'sub.reason.notUsing': 'Not using it enough',
  'sub.reason.missingFeatures': 'Missing features',
  'sub.reason.foundAlternative': 'Found an alternative',
  'sub.reason.other': 'Other',
  'sub.confirmType': 'Confirmation: Type "CANCEL" *',
  'sub.cancelNow': 'Cancel now',
  // Add Card Modal
  'sub.addCardTitle': 'Add New Card',
  'sub.cardHolder': 'Card Holder *',
  'sub.cardNumber': 'Card Number *',
  'sub.expiryDate': 'Expiry Date *',
  'sub.addCard': 'Add card',
  // Change Card Modal
  'sub.choosePayment': 'Choose payment method',
  'sub.active': 'Active',
  'sub.close': 'Close',
  // Toast messages
  'sub.toast.cancelled': 'Your subscription has been cancelled at the end of the billing period.',
  'sub.toast.reactivated': 'Your subscription has been successfully reactivated!',
  'sub.toast.planChanged': 'Plan successfully changed to {{plan}}!',
  'sub.toast.defaultChanged': 'Default payment method changed.',
  'sub.toast.cannotDeleteDefault': 'The default card cannot be deleted.',
  'sub.toast.cardRemoved': 'Card has been removed.',
  'sub.toast.fillAll': 'Please fill in all fields.',
  'sub.toast.cardAdded': 'New card successfully added!',
  'sub.toast.billingSaved': 'Billing address saved.',
  'sub.toast.invoiceDownloaded': 'Invoice {{id}} downloaded!',
  'sub.toast.pdfError': 'Error creating PDF.',
  // Chat interface
  'sub.notEnoughCredits': 'Not enough credits',
  'sub.needCredits': 'You need at least {{count}} credits per question.',
  'sub.creditsLow': 'Credits running low',
  'sub.questionsLeft': '{{count}} questions possible.',
  'sub.plan': 'Plan',
  'sub.base': 'base',
  'sub.unlimited': 'Unlimited',
  'sub.status.active': 'Active',
  'sub.status.cancelled': 'Cancelled',
  'sub.status.paused': 'Paused',
  'sub.invoice': 'INVOICE',
  'sub.from': 'FROM',
  'sub.to': 'TO',
  'sub.vatId': 'VAT ID',
  'sub.tel': 'Tel',
  'sub.invoiceDate': 'Invoice date',
  'sub.invoiceNumber': 'Invoice number',
  'sub.paymentStatus': 'Payment status',
  'sub.creditCard': 'Credit card',
  'sub.quantity': 'QTY',
  'sub.price': 'PRICE',
  'sub.amount': 'AMOUNT',
  'sub.subtotal': 'Subtotal',
  'sub.bank': 'Bank',
  'sub.card': 'Card',
  'sub.cvc': 'CVC',
  'sub.cardHolderPlaceholder': 'John Doe',

  // ─── Admin Panel ─────────────────────────────────────────────────────────────
  'admin.title': 'Admin Dashboard',
  'admin.subtitle': 'Control Center',
  'admin.superAdmin': 'Super Admin',
  'admin.logout': 'Sign Out',
  'admin.tabs.users': 'User Management',
  'admin.tabs.downgrades': 'Downgrades',
  'admin.tabs.tips': 'Tip of the Day',
  'admin.tabs.coupons': 'Coupon Codes',
  'admin.tabs.website': 'Website Editor',
  'admin.tabs.ai': 'AI Settings',
  'admin.tabs.transactions': 'Transaction Log',
  'admin.tabs.stats': 'Statistics',
  'admin.users.searchPlaceholder': 'Search users (email or name)...',
  'admin.users.manageSubscription': 'Manage subscription',
  'admin.users.grantFree': 'Grant free account',
  'admin.users.blockUser': 'Block user',
  'admin.users.cancellationPlaceholder': 'Why is the subscription being cancelled?',
  'admin.users.selectPlan': 'Select plan',
  'admin.users.subChanged': 'Subscription of {{name}} changed to {{plan}}',
  'admin.users.noReasonGiven': 'No reason given',
  'admin.users.subCancelled': 'Subscription of {{name}} cancelled (valid until {{date}})',
  'admin.users.paused': 'Paused',
  'admin.users.subPaused': 'Subscription of {{name}} has been paused',
  'admin.users.subReactivated': 'Subscription of {{name}} has been reactivated',
  'admin.users.freeAccount': 'Free Account',
  'admin.users.blocked': 'Blocked',
  'admin.users.cancelledExpiring': 'Cancelled (expiring)',
  'admin.users.cancelledOn': 'Cancelled:',
  'admin.users.endsOn': 'Ends:',
  'admin.users.daysRemaining': 'days remaining',
  'admin.users.expired': '(Expired)',
  'admin.users.total': 'Total:',
  'admin.users.usersLabel': 'users',
  'admin.users.free': 'free',
  'admin.users.block': 'Block',
  'admin.users.unblock': 'Unblock',
  'admin.users.unblockUser': 'Unblock user',
  'admin.users.selectAction': 'Select action',
  'admin.users.cancelSub': 'Cancel subscription',
  'admin.users.cancelSubDesc': 'Cancellation at end of month',
  'admin.users.pauseSub': 'Pause subscription',
  'admin.users.pauseSubDesc': 'Temporary pause',
  'admin.users.changePlan': 'Change plan',
  'admin.users.changePlanDesc': 'Switch to another plan',
  'admin.users.reactivateSub': 'Reactivate subscription',
  'admin.users.reactivateDesc': 'Undo cancellation',
  'admin.users.alreadyCancelled': 'Subscription already cancelled',
  'admin.users.planLabel': 'Plan',
  'admin.users.cancellationReasonOpt': 'Cancellation reason (optional)',
  'admin.users.cancelInfo1': 'The subscription will end on',
  'admin.users.cancelInfo2': '(end of month). Until then the user has full access. No refund.',
  'admin.users.newPlan': 'New plan',
  'admin.users.warning': 'Warning',
  'admin.users.blockDesc': 'The user will be immediately logged out and cannot log in again. All active sessions will be terminated.',
  'admin.users.confirmUnblock': 'Confirm unblock',
  'admin.users.unblockDesc': 'The user can log in again and use all features.',
  'admin.users.afterBlock': 'After blocking:',
  'admin.users.afterUnblock': 'After unblocking:',
  'admin.users.noAccountAccess': 'No account access',
  'admin.users.noNewAnalyses': 'No new analyses possible',
  'admin.users.creditsStored': 'Credits and history remain stored',
  'admin.users.accessRestored': 'Account access restored',
  'admin.users.allFeaturesAvail': 'All features available again',
  'admin.users.creditsPreserved': 'Credits and history preserved',
  'admin.users.downgrade': 'Downgrade Plan',
  'admin.users.grantFreeBtn': 'Grant free',
  'admin.users.durationMonths': 'Duration (months)',
  'admin.users.months': 'month(s)',
  'admin.users.freePlan': 'free',
  'admin.users.freeSummary': 'receives',
  'admin.users.withCredits': 'with',
  'admin.users.credits': 'Credits',
  'admin.users.subInfo': 'Subscription Information',
  'admin.users.currentPlan': 'Current Plan',
  'admin.users.joined': 'Joined',
  'admin.users.totalSpent': 'Total Spent',
  'admin.users.paymentMethod': 'Payment Method',
  'admin.users.validThrough': 'Valid through',
  'admin.users.billingAddress': 'Billing Address',
  'admin.users.transactionHistory': 'Transaction History',
  'admin.users.cancellationDate': 'Cancellation date',
  'admin.users.validUntil': 'Valid until (end of month)',
  'admin.users.cancellationReason': 'Cancellation reason',
  'admin.users.noReason': 'No reason given',
  'admin.users.timeRemaining': 'Time remaining',
  'admin.users.daysUntilDeactivation': 'days until deactivation',
  'admin.table.user': 'User',
  'admin.table.plan': 'Plan',
  'admin.table.subStatus': 'Subscription Status',
  'admin.table.cancellation': 'Cancellation',
  'admin.table.payment': 'Payment Method',
  'admin.table.spending': 'Spending',
  'admin.table.actions': 'Actions',
  'admin.actions.viewDetails': 'View details',
  'admin.actions.manageSubscription': 'Manage subscription',
  'admin.actions.grantFree': 'Grant free access',
  'admin.actions.block': 'Block user',
  'admin.actions.unblock': 'Unblock user',
  'admin.actions.cancel': 'Cancel',
  'admin.actions.save': 'Save',
  'admin.actions.delete': 'Delete',
  'admin.actions.confirm': 'Confirm',
  'admin.actions.done': 'Done',
  'admin.actions.edit': 'Edit',
  'admin.actions.close': 'Close',
  'admin.table.status': 'Status',
  'admin.filter.all': 'All',
  'admin.subscription.active': 'Active',
  'admin.subscription.cancelled': 'Cancelled',
  'admin.subscription.paused': 'Paused',
  'admin.subscription.unknown': 'Unknown',
  'admin.status.active': 'Active',
  'admin.status.inactive': 'Inactive',
  'admin.status.pending': 'Pending',
  'admin.status.approved': 'Approved',
  'admin.status.rejected': 'Rejected',
  'admin.coupons.title': 'Coupon Management',
  'admin.coupons.subtitle': 'Create and manage coupon codes',
  'admin.coupons.newCoupon': 'New Coupon',
  'admin.coupons.registrationCoupons': 'Registration Coupons',
  'admin.coupons.trialCoupons': 'Trial Access Coupons',
  'admin.coupons.type': 'Type',
  'admin.coupons.plan': 'Plan',
  'admin.coupons.value': 'Value',
  'admin.coupons.usage': 'Usage',
  'admin.coupons.validUntil': 'Valid Until',
  'admin.coupons.created': 'Created',
  'admin.coupons.actions': 'Actions',
  'admin.coupons.copyCode': 'Copy code',
  'admin.coupons.allPlans': 'All Plans',
  'admin.coupons.discount': 'Discount',
  'admin.coupons.days': 'days',
  'admin.coupons.months': 'months',
  'admin.coupons.free': 'free',
  'admin.coupons.unlimited': 'Unlimited',
  'admin.coupons.createRegistration': 'Create Registration Coupon',
  'admin.coupons.createTrial': 'Create Trial Access Coupon',
  'admin.coupons.couponCode': 'Coupon Code',
  'admin.coupons.codePlaceholder': 'e.g. NF-7X3K9M',
  'admin.coupons.generateCode': 'Generate new code',
  'admin.coupons.alertFillRequired': 'Please fill in all required fields',
  'admin.coupons.alertSelectExpiry': 'Please select an expiry date or enable "Unlimited validity"',
  'admin.coupons.alertCreateError': 'Error creating coupon',
  'admin.coupons.confirmDelete': 'Are you sure you want to delete this coupon?',
  'admin.coupons.discountPercent': 'Discount (%)',
  'admin.coupons.bonusCredits': 'Bonus Credits',
  'admin.coupons.freeDuration': 'Free Duration',
  'admin.coupons.maxUses': 'Max Uses',
  'admin.coupons.expiryDate': 'Expiry Date',
  'admin.coupons.unlimitedValidity': 'Unlimited validity',
  'admin.coupons.unlimitedUses': 'Unlimited uses',
  'admin.coupons.trialCredits': 'Trial Credits',
  'admin.coupons.trialDuration': 'Trial Duration',
  'admin.coupons.typePlaceholder': 'e.g. Early Bird, Partner, Influencer',
  'admin.coupons.duration': 'Duration',
  'admin.stats.totalUsers': 'Total Users',
  'admin.stats.monthlyRevenue': 'Monthly Revenue',
  'admin.stats.activeSubscriptions': 'Active Subscriptions',
  'admin.stats.average': 'Average',
  'admin.stats.revenuePerUser': 'Revenue per User',
  'admin.stats.grossRevenue': 'Gross Revenue',
  'admin.stats.net': 'NET',
  'admin.stats.netRevenue': 'Net Revenue',
  'admin.stats.churnRate': 'Churn Rate',
  'admin.stats.planDistribution': 'Plan Distribution',
  'admin.stats.users': 'users',
  'admin.stats.revenueByPlan': 'Revenue by Plan',
  'admin.stats.recentActivity': 'Recent Activity',
  'admin.stats.activity1': 'Thomas Weber upgraded to Builder',
  'admin.stats.activity2': 'New user registered',
  'admin.stats.activity3': 'Anna Schmidt upgraded to Pro',
  'admin.stats.hoursAgo2': '2 hours ago',
  'admin.stats.hoursAgo5': '5 hours ago',
  'admin.stats.dayAgo1': '1 day ago',
  'admin.stats.couponStats': 'Coupon Statistics',
  'admin.stats.totalRedemptions': 'Total Redemptions',
  'admin.stats.activeCoupons': 'Active Coupons',
  'admin.stats.registrationRedemptions': 'Registration Redemptions',
  'admin.stats.trialRedemptions': 'Trial Redemptions',
  'admin.stats.couponDistribution': 'Coupon Distribution',
  'admin.stats.registrationCoupons': 'Registration Coupons',
  'admin.stats.trialCoupons': 'Trial Coupons',
  'admin.stats.expiredInactive': 'Expired/Inactive',
  'admin.stats.topCoupons': 'Top Coupons by Redemptions',
  'admin.stats.redemptions': 'redemptions',
  'admin.stats.noCouponsRedeemed': 'No coupons redeemed yet',
  'admin.downgrade.pending': 'pending',
  'admin.downgrade.refunds': 'Refunds',
  'admin.downgrade.sectionRequests': 'Requests',
  'admin.downgrade.sectionStats': 'Statistics',
  'admin.downgrade.sectionRules': 'Rules',
  'admin.downgrade.pendingRequests': 'Pending Requests',
  'admin.downgrade.approvedRequests': 'Approved Requests',
  'admin.downgrade.rejectedRequests': 'Rejected Requests',
  'admin.downgrade.activeRules': 'Active Rules',
  'admin.downgrade.autoRules': 'Automatic Downgrade Rules',
  'admin.downgrade.autoRulesDesc': 'Create rules that automatically trigger downgrades based on usage behavior',
  'admin.downgrade.newRule': 'New Rule',
  'admin.downgrade.totalRules': 'Total Rules',
  'admin.downgrade.triggeredActions': 'Triggered Actions',
  'admin.downgrade.conditionsAnd': 'Conditions (AND linked)',
  'admin.downgrade.action': 'Action',
  'admin.downgrade.successTitle': 'Downgrade successful!',
  'admin.downgrade.successDesc': 'The user has been successfully downgraded and the refund has been processed.',
  'admin.downgrade.closing': 'Closing...',
  'admin.downgrade.title': 'Downgrade User',
  'admin.downgrade.currentPlan': 'Current Plan',
  'admin.downgrade.spending': 'Spending',
  'admin.downgrade.availablePlans': 'Available Plans for Downgrade',
  'admin.downgrade.perMonth': 'per month',
  'admin.downgrade.refundCalc': 'Refund Calculation',
  'admin.downgrade.currentPlanLabel': 'Current Plan',
  'admin.downgrade.newPlan': 'New Plan',
  'admin.downgrade.remainingDays': 'Remaining Days',
  'admin.downgrade.daysOf': '15 of 30 days',
  'admin.downgrade.proRataRefund': 'Pro-rata Refund',
  'admin.downgrade.importantNote': 'Important Note',
  'admin.downgrade.warningDesc': 'The downgrade will be executed immediately. The user will lose access to premium features and excess credits will be removed.',
  'admin.downgrade.processing': 'Processing...',
  'admin.downgrade.execute': 'Execute Downgrade',
  'admin.downgrade.notification': 'Notification',
  'admin.downgrade.noNotification': 'No Notification',
  'admin.downgrade.daysPeriod': 'days grace period',
  'admin.downgrade.created': 'Created:',
  'admin.downgrade.triggered': 'triggered',
  'admin.downgrade.noRules': 'No rules created yet',
  'admin.downgrade.createFirstRule': 'Create first rule',
  'admin.downgrade.editRule': 'Edit Rule',
  'admin.downgrade.createRule': 'Create New Rule',
  'admin.downgrade.ruleName': 'Rule name',
  'admin.downgrade.description': 'Description',
  'admin.downgrade.allConditions': 'Conditions (all must be met)',
  'admin.downgrade.addCondition': 'Add condition',
  'admin.downgrade.type': 'Type',
  'admin.downgrade.value': 'Value',
  'admin.downgrade.fromPlan': 'From plan',
  'admin.downgrade.toPlan': 'To plan',
  'admin.condition.inactivity': 'Inactivity',
  'admin.condition.creditUsage': 'Credit Usage',
  'admin.condition.loginFrequency': 'Login Frequency',
  'admin.condition.featureUsage': 'Feature Usage',
  'admin.condition.supportTickets': 'Support Tickets',
  'admin.operator.lessThan': 'less than',
  'admin.operator.greaterThan': 'more than',
  'admin.operator.equals': 'exactly',
  'admin.operator.between': 'between',
  'admin.unit.days': 'days',
  'admin.unit.perMonth': 'per month',
  'admin.unit.count': 'count',
  'admin.transactions.all': 'All Transactions',
  'admin.transactions.allCards': 'All Cards',
  'admin.transactions.notFound': 'No transactions found',
  'admin.transactions.totalLabel': 'Total',
  'admin.transactions.transactions': 'transactions',
  'admin.tips.title': 'Tip of the Day',
  'admin.tips.subtitle': 'Create and manage tips shown to all users',
  'admin.tips.active': 'Active',
  'admin.tips.currentlyShown': 'This tip is currently shown to all users',
  'admin.tips.createNew': 'Create New Tip',
  'admin.tips.generating': 'Generating...',
  'admin.tips.generateAI': 'Generate AI Tip',
  'admin.tips.titleLabel': 'Title',
  'admin.tips.titlePlaceholder': 'e.g. Tip of the Day',
  'admin.tips.category': 'Category',
  'admin.tips.categoryTip': 'Tip',
  'admin.tips.categoryFeature': 'New Feature',
  'admin.tips.categoryProductivity': 'Productivity',
  'admin.tips.categoryUpdate': 'Update',
  'admin.tips.content': 'Content',
  'admin.tips.contentPlaceholder': 'Write your tip for users here...',
  'admin.tips.addTip': 'Add Tip',
  'admin.tips.allTips': 'All Tips',
  'admin.tips.noTips': 'No tips created yet',
  'admin.tips.noTipsHint': 'Click "Generate AI Tip" to get started',
  'admin.noData': 'No data available',
  'admin.range.7d': '7 days',
  'admin.range.30d': '30 days',
  'admin.range.90d': '90 days',
  'admin.range.1y': '1 year',
  'admin.actions.saveSettings': 'Save settings',
  'admin.actions.create': 'Create',
  'admin.downgrade.sectionReports': 'Reports',
  'admin.downgrade.settings': 'Downgrade Settings',
  'admin.downgrade.autoApprove': 'Automatic Approval',
  'admin.downgrade.autoApproveDesc': 'Automatically approve downgrade requests',
  'admin.downgrade.refundPolicy': 'Refund Policy',
  'admin.downgrade.prorata': 'Pro-rata refund',
  'admin.downgrade.prorataDesc': 'Proportional refund based on remaining days',
  'admin.downgrade.fullRefund': 'Full refund',
  'admin.downgrade.fullRefundDesc': 'Complete refund of the price difference',
  'admin.downgrade.noRefund': 'No refund',
  'admin.downgrade.noRefundDesc': 'Downgrade without refund',
  'admin.downgrade.daysRemaining15': '(with 15 days remaining)',
  'admin.downgrade.requestsTitle': 'Downgrade Requests',
  'admin.downgrade.approvalRate': 'Approval rate',
  'admin.downgrade.mostCommonTransition': 'Most common transition',
  'admin.downgrade.mostCommonReason': 'Most common reason',
  'admin.downgrade.avgProcessingTime': 'Avg. processing time',
  'admin.downgrade.avgTimeDesc': 'Average time to decision',
  'admin.downgrade.totalRefunds': 'Total Refunds',
  'admin.downgrade.pendingRefunds': 'Pending Refunds',
  'admin.downgrade.summary': 'Summary',
  'admin.downgrade.total': 'Total',
  'admin.downgrade.csvDesc': 'For Excel, Google Sheets',
  'admin.downgrade.downloadCSV': 'Download as CSV',
  'admin.downgrade.jsonDesc': 'For developers, APIs',
  'admin.downgrade.downloadJSON': 'Download as JSON',
  'admin.downgrade.exportInfo': 'The export contains',
  'admin.downgrade.entries': 'entries from the selected period',
  'admin.downgrade.topReasons': 'Most common downgrade reasons',
  'admin.downgrade.refundHistory': 'Refund History',
  'admin.downgrade.noRefunds': 'No refunds yet',
  'admin.downgrade.statistics': 'Downgrade Statistics',
  'admin.downgrade.requests': 'Requests',
  'admin.downgrade.monthlyTrend': 'Monthly Trend',
  'admin.downgrade.planTransitions': 'Plan Transitions',
  'admin.downgrade.trend': 'Trend (vs. prev. month)',
  'admin.downgrade.trendDesc': 'Fewer downgrades = better',
  'admin.coupons.allPlansUniversal': 'All Plans (Universal)',
  'admin.coupons.onlyStarter': 'Starter only',
  'admin.coupons.onlyPro': 'Pro only',
  'admin.coupons.onlyBuilder': 'Builder only',
  'admin.coupons.allPlansHint': 'Choose "All Plans" for a universal coupon',
  'admin.coupons.discountOptional': 'Discount % (optional)',
  'admin.coupons.discountPlaceholder': 'e.g. 50 for 50% discount',
  'admin.coupons.bonusCreditsOptional': 'Bonus Credits (optional)',
  'admin.coupons.bonusCreditsPlaceholder': 'e.g. 500',
  'admin.coupons.freeDurationOptional': 'Free Duration (optional)',
  'admin.coupons.durationPlaceholder': 'e.g. 30',
  'admin.coupons.freeDurationHint': 'e.g. 30 days free to use',
  'admin.coupons.noLimit': 'No usage limitation',
  'admin.coupons.noExpiry': 'No expiry date',
  'admin.coupons.creditsPlaceholder': 'e.g. 100',
  'admin.coupons.creditsHint': 'Number of credits for the trial access',
  'admin.coupons.trialDurationHint': 'How long the trial access is valid',
  'admin.coupons.autoCalculated': 'Automatically calculated from trial duration',
  'admin.websiteEditor.title': 'Website Editor',
  'admin.websiteEditor.subtitle': 'Edit all sections of the homepage',
  'admin.websiteEditor.openPreview': 'Open Preview',
  'admin.websiteEditor.group.structure': 'Page Structure',
  'admin.websiteEditor.group.design': 'Design & Layout',
  'admin.websiteEditor.group.settings': 'Settings',
  'admin.websiteEditor.tab.navbar': 'Navigation',
  'admin.websiteEditor.tab.howitworks': 'How It Works',
  'admin.websiteEditor.tab.about': 'About Us',
  'admin.websiteEditor.tab.pricing': 'Pricing',
  'admin.websiteEditor.tab.sections': 'Sections',
  'admin.websiteEditor.tab.media': 'Media',
  'admin.websiteEditor.tab.chatwidget': 'Talk with Us',
  'admin.websiteEditor.tab.invoice': 'Invoices',
  'admin.websiteEditor.tab.legal': 'Legal',
  'admin.websiteEditor.tab.seo': 'SEO Basic',
  'admin.websiteEditor.tab.advancedseo': 'SEO Advanced',
  'admin.websiteEditor.tab.versions': 'Versions',
  'admin.hero.title': 'Edit Hero Section',
  'admin.hero.subtitle': 'Texts, buttons and statistics of the homepage',
  'admin.hero.reset': 'Reset',
  'admin.hero.save': 'Save',
  'admin.hero.savedMsg': 'Hero data saved!',
  'admin.hero.badge': 'Badge Text',
  'admin.hero.headings': 'Headings',
  'admin.hero.line1White': 'Line 1 (white)',
  'admin.hero.line2Gold': 'Line 2 (gold)',
  'admin.hero.subtitleSection': 'Subtitle',
  'admin.hero.line1': 'Line 1',
  'admin.hero.line2': 'Line 2',
  'admin.hero.buttons': 'Buttons',
  'admin.hero.primaryBtn': 'Primary Button (gold)',
  'admin.hero.secondaryBtn': 'Secondary Button (border)',
  'admin.hero.stats': 'Statistics',
  'admin.hero.statN': 'Statistic {{n}}',
  'admin.hero.value': 'Value',
  'admin.hero.label': 'Label',
  'admin.hero.previewNote': 'Changes will be visible on the homepage after saving. Reload the page to see the preview.',

  // Idea History
  'history.title': 'Idea History',
  'history.countLabel': '{{count}} analyses',
  'history.recentLabel': 'Your recent analyses',
  'history.exportAll': 'Export all',
  'history.metrics.marketSize': 'Market Size',
  'history.metrics.competition': 'Competition',
  'history.metrics.startingCapital': 'Starting Capital',
  'history.metrics.timeToMarket': 'Time to Market',
  'history.metrics.profitPotential': 'Profit Potential',
  'history.metrics.scalability': 'Scalability',
  'history.summary.title': 'Summary',
  'history.download': 'Download',
  'history.downloadJSON': 'Save as JSON',
  'history.downloadTXT': 'Save as TXT',
  'history.downloadPDF': 'Save as PDF',
  'history.fullAnalysis': 'Full Analysis',
  'history.searchPlaceholder': 'Search by title or tags...',
  'history.filterAll': 'All ratings',
  'history.loading': 'Loading analyses...',
  'history.noResults': 'No results found',
  'history.empty': 'No analyses yet',
  'history.emptyHint': 'Start an analysis in the AI Assistant',
  'history.delete': 'Delete',
  'history.cancel': 'Cancel',
  'history.deleteModalTitle': 'Delete analysis?',
  'history.deleteModalDesc': '"{{title}}" will be permanently deleted.',
  'history.errorLoading': 'Error loading analyses',
  'history.deleteSuccess': 'Analysis successfully deleted',
  'history.deleteError': 'Error deleting analysis',
  'history.jsonExported': 'JSON exported',
  'history.txtExported': 'TXT exported',
  'history.allExported': '{{count}} ideas exported',
  'history.analysisHeader': 'IDEA ANALYSIS',
  'history.titleLabel': 'Title',
  'history.ratingLabel': 'Rating',
  'history.dateLabel': 'Date',
  'history.creditsLabel': 'Credits',
  'history.analysisSection': 'Analysis',

  // Overview
  'overview.title': 'Overview',
  'overview.last24h': 'Last 24 hours',
  'overview.analysesToday': 'Analyses today',
  'overview.totalAnalyses': 'Total analyses',
  'overview.successRate': 'Success rate',
  'overview.topRatings': 'Top ratings',
  'overview.recentActivity': 'Recent activity',
  'overview.viewAll': 'View all',
  'overview.quickAccess': 'Quick access',
  'overview.quick.newAnalysis': 'Start new analysis',
  'overview.quick.newAnalysisDesc': 'Start a new AI-powered niche analysis',
  'overview.quick.myAnalyses': 'My analyses',
  'overview.quick.myAnalysesDesc': 'View all previous analyses',
  'overview.quick.buyCredits': 'Buy credits',
  'overview.quick.buyCreditsDesc': 'More credits for more analyses',
  'overview.quick.settings': 'Settings',
  'overview.quick.settingsDesc': 'Customize profile and preferences',
  'overview.unlimitedCredits': 'Unlimited credits available',
  'overview.creditsAvailable': 'credits available',
  'overview.upgradePlan': 'Upgrade plan',
  'overview.buyCredits': 'Buy credits',
  'overview.creditUsage': 'Credit usage this month',
  'overview.available': 'available',

  // --- Admin New Keys ---
  'admin.transactions.upgrades': 'Upgrades',
  'admin.transactions.downgrades': 'Downgrades',
  'admin.transactions.visa': 'Visa',
  'admin.transactions.mastercard': 'Mastercard',
  'admin.transactions.amex': 'Amex',
  
  'admin.users.grantFreeSuccess': '{{name}} now has {{months}} month(s) of free {{plan}} plan',
  'admin.users.blockSuccess': '{{name}} was blocked',
  'admin.users.unblockSuccess': '{{name}} was unblocked',
  'admin.users.removeFreeSuccess': 'Free status of {{name}} was removed',
  
  'admin.downgrade.plans.builder': 'Builder',
  'admin.downgrade.plans.pro': 'Pro',
  'admin.downgrade.plans.starter': 'Starter',
  'admin.downgrade.plans.free': 'Free',
  
  'admin.unit.percent': '%',

  'admin.tips.discoverNewFeature': 'Discover New Feature',
  'admin.tips.productivityBoost': 'Productivity Boost',
  'admin.tips.importantUpdate': 'Important Update',
  'admin.tips.tipOfDay': 'Tip of the Day',

  'admin.actions.activate': 'Activate',
  'admin.actions.deactivate': 'Deactivate',
  'admin.websiteEditor.tab.features': 'Features',
  'admin.websiteEditor.tab.testimonials': 'Testimonials',
  'admin.websiteEditor.tab.faq': 'FAQ',
  'admin.websiteEditor.tab.cta': 'CTA',
  'admin.websiteEditor.tab.footer': 'Footer',
  'admin.websiteEditor.tab.design': 'Design',
  'admin.websiteEditor.tab.customcode': 'Custom Code',
  'admin.websiteEditor.tab.socials': 'Social Media',
  'admin.websiteEditor.tab.importexport': 'Import/Export',

  // --- AI Settings Editor ---
  'admin.ai.title': 'AI Assistant Settings',
  'admin.ai.subtitle': 'Configure behavior, style and analysis depth',
  'admin.ai.smartWeightingActive': 'Smart Weighting Active',
  'admin.ai.smartWeightingDesc': 'The AI automatically combines all perspectives with smart weighting. With multiple presets, the first one is weighted more heavily (primary preset). You can also adjust the weighting manually.',
  'admin.ai.modelTitle': 'IdeaVerdict AI Model',
  'admin.ai.modelSubtitle': 'Choose the AI engine for all user analyses',
  'admin.ai.activeModel': 'Active model:',
  'admin.ai.activeModelDesc': 'All users receive responses from this model.',
  'admin.ai.recommendations': 'Recommendations for Optimal Results',
  'admin.ai.new': 'NEW',
  'admin.ai.recommendationsDesc': 'Proven preset combinations for best analysis quality',
  'admin.ai.recommendationsInfo': 'These combinations have been tested and deliver the best results. Click a recommendation to apply it directly.',
  'admin.ai.active': 'ACTIVE',
  'admin.ai.apply': 'Apply',
  'admin.ai.avoid': 'Avoid',
  'admin.ai.excellentQuality': 'Excellent Quality',
  'admin.ai.goodQuality': 'Good Quality',
  'admin.ai.poorQuality': 'Diluted Quality - Not Recommended',
  'admin.ai.proTips': 'Pro Tips',
  'admin.ai.tip1Title': '2 presets are optimal:',
  'admin.ai.tip1Desc': 'Clear perspective without dilution',
  'admin.ai.tip2Title': 'Primary preset matters:',
  'admin.ai.tip2Desc': 'The first preset has the greatest influence',
  'admin.ai.tip3Title': 'Avoid opposites:',
  'admin.ai.tip3Desc': '"EXTREME" + "Creative" = contradictory',
  'admin.ai.tip4Title': 'Maximum 3 presets:',
  'admin.ai.tip4Desc': 'With 4+ presets the result becomes too general',
  'admin.ai.warningManyPresets': 'Warning: Many Presets',
  'admin.ai.warningManyPresetsDesc': 'You have {{count}} presets selected. This can dilute the result.',
  'admin.ai.warningRecommend': 'Recommended: Maximum 2-3 presets',
  'admin.ai.forOptimalResults': 'for optimal results.',
  'admin.ai.presets': 'Presets',
  'admin.ai.multiSelect': '(multiple selection possible)',
  'admin.ai.presetsDesc': 'Choose one or more presets. The first preset is the primary preset with the highest weighting.',
  'admin.ai.primaryPreset': 'Primary Preset',
  'admin.ai.weightControl': 'Weight Control',
  'admin.ai.weightControlDesc': 'Adjust how strongly each preset influences the analysis',
  'admin.ai.manual': 'Manual',
  'admin.ai.automatic': 'Automatic',
  'admin.ai.autoWeightingActive': 'Automatic weighting active:',
  'admin.ai.autoWeightingDesc': 'The weighting is automatically optimized based on the number of presets.',
  'admin.ai.primary': 'PRIMARY',
  'admin.ai.totalWeight': 'Total',
  'admin.ai.shouldBe100': 'should be 100%',
  'admin.ai.normalize': 'Normalize',
  'admin.ai.combinedSettings': 'Combined Settings',
  'admin.ai.presetsCount': 'presets',
  'admin.ai.strictness': 'Strictness',
  'admin.ai.realism': 'Realism',
  'admin.ai.creativity': 'Creativity',
  'admin.ai.detailLevel': 'Detail Level',
  'admin.ai.customInstructions': 'Custom Instructions',
  'admin.ai.customInstructionsDesc': 'Additional instructions that are combined with the presets',
  'admin.ai.customInstructionsPlaceholder': 'e.g. "Focus on the DACH market", "Always use concrete numbers", "Compare with existing competitors", "Always answer with examples"...',
  'admin.ai.customInstructionsHint': 'These instructions are automatically combined with the selected presets.',
  'admin.ai.manualFinetuning': 'Manual Fine-Tuning',
  'admin.ai.manualFinetuningHint': '(optional, overrides preset values)',
  'admin.ai.manualFinetuningDesc': 'Manually adjust the combined values if you want to fine-tune something.',
  'admin.ai.tone': 'Tone',
  'admin.ai.mild': 'Mild',
  'admin.ai.strict': 'Strict',
  'admin.ai.creative': 'Creative',
  'admin.ai.realistic': 'Realistic',
  'admin.ai.conservative': 'Conservative',
  'admin.ai.compact': 'Compact',
  'admin.ai.detailed': 'Detailed',
  'admin.ai.responseLength': 'Response Length',
  'admin.ai.short': 'Short & Concise',
  'admin.ai.medium': 'Medium',
  'admin.ai.long': 'Detailed',
  'admin.ai.focusAreas': 'Analysis Focus Areas',
  'admin.ai.autoRating': 'Automatic Rating',
  'admin.ai.autoRatingDesc': 'Every analysis automatically receives a rating (Good/Medium/Bad)',
  'admin.ai.showSources': 'Show Sources',
  'admin.ai.showSourcesDesc': 'References to data sources and market data in responses',
  'admin.ai.hidePreview': 'Hide Preview',
  'admin.ai.showPreview': 'Show Preview',
  'admin.ai.aiBehavior': 'AI Behavior',
  'admin.ai.length': 'Length',
  'admin.ai.liveExample': 'Live Example',
  'admin.ai.testSettings': 'Test your settings',
  'admin.ai.selectExampleQuestion': 'Select example question:',
  'admin.ai.userAsks': 'User asks:',
  'admin.ai.generating': 'AI generating response...',
  'admin.ai.generateExample': 'Generate Example Response',
  'admin.ai.aiResponds': 'AI Assistant responds:',
  'admin.ai.generateHint': 'Click "Generate Example Response" to see how the AI responds with your settings.',
  'admin.ai.reset': 'Reset',
  'admin.ai.saved': 'Saved!',
  'admin.ai.saveSettings': 'Save Settings',

  // --- Table headers ---
  'admin.coupons.code': 'Code',
  'admin.coupons.credits': 'Credits',

  // --- AI Model Descriptions ---
  'admin.ai.model.standardDesc': 'Balanced analysis with high quality. The best choice for most niche assessments and idea validations.',
  'admin.ai.model.preciseAnalyses': 'Precise Analyses',
  'admin.ai.model.bestBalance': 'Best Balance',
  'admin.ai.model.recommended': 'Recommended',
  'admin.ai.model.fastDesc': 'Lightning-fast responses for quick niche checks, brainstorming and initial assessments. Ideal when speed matters.',
  'admin.ai.model.fast': 'FAST',
  'admin.ai.model.fastestResponses': 'Fastest Responses',
  'admin.ai.model.thinkingDesc': 'Deep analysis with advanced logical thinking. For complex market analyses, critical assessments and strategic planning.',
  'admin.ai.model.deepestAnalysis': 'Deepest Analysis',
  'admin.ai.model.logicalThinking': 'Logical Thinking',
  'admin.ai.model.strategy': 'Strategy',

  // --- AI Preset Names & Descriptions ---
  'admin.ai.preset.strict.name': 'Strict Analysis',
  'admin.ai.preset.strict.desc': 'Critical, fact-based, no sugarcoating. Exposes weaknesses ruthlessly.',
  'admin.ai.preset.extreme.name': 'EXTREME Analysis',
  'admin.ai.preset.extreme.desc': 'Maximum strictness, ruthless criticism, worst-case focus. Only for tough reality checks.',
  'admin.ai.preset.professional.name': 'Professional',
  'admin.ai.preset.professional.desc': 'Objective, structured, balanced. Like an experienced business consultant.',
  'admin.ai.preset.realistic.name': 'Realistic',
  'admin.ai.preset.realistic.desc': 'Honest and practical. Focus on feasible implementation and real market data.',
  'admin.ai.preset.creative.name': 'Creative & Motivating',
  'admin.ai.preset.creative.desc': 'Inspiring, idea-rich, positive. Finds opportunities and unconventional paths.',
  'admin.ai.preset.balanced.name': 'Balanced',
  'admin.ai.preset.balanced.desc': 'Good mix of criticism and motivation. The default mode.',
  'admin.ai.preset.investor.name': 'Investor Perspective',
  'admin.ai.preset.investor.desc': 'Like a Venture Capitalist. Focus on scaling, ROI and exit strategy.',
  'admin.ai.preset.startup-coach.name': 'Startup Coach',
  'admin.ai.preset.startup-coach.desc': 'Practical mentor for founders. Focus on quick implementation and MVP.',
  'admin.ai.preset.market-researcher.name': 'Market Researcher',
  'admin.ai.preset.market-researcher.desc': 'Data-driven and analytical. Deep market and competitive analysis.',
  'admin.ai.preset.risk-analyst.name': 'Risk Analyst',
  'admin.ai.preset.risk-analyst.desc': 'Focus on risks and worst-case scenarios. For realistic planning.',

  // --- Focus Areas ---
  'admin.ai.focus.marktanalyse': 'Market Analysis',
  'admin.ai.focus.wettbewerb': 'Competition',
  'admin.ai.focus.monetarisierung': 'Monetization',
  'admin.ai.focus.risiken': 'Risks',
  'admin.ai.focus.finanzen': 'Finance',
  'admin.ai.focus.skalierung': 'Scaling',
  'admin.ai.focus.innovation': 'Innovation',
  'admin.ai.focus.trends': 'Trends',
  'admin.ai.focus.differenzierung': 'Differentiation',
  'admin.ai.focus.umsetzung': 'Implementation',
  'admin.ai.focus.zielgruppe': 'Target Audience',
  'admin.ai.focus.marketing': 'Marketing',

  // --- Tone Options ---
  'admin.ai.tone.direkt': 'Direct & Blunt',
  'admin.ai.tone.professionell': 'Professional & Objective',
  'admin.ai.tone.ehrlich': 'Honest & Practical',
  'admin.ai.tone.motivierend': 'Motivating & Positive',
  'admin.ai.tone.freundlich': 'Friendly & Supportive',
  'admin.ai.tone.akademisch': 'Academic & Analytical',

  // --- Example Questions ---
  'admin.ai.question.niche': 'Which profitable niche do you recommend?',
  'admin.ai.question.evaluate': 'Rate my idea: An app for dog owners',
  'admin.ai.question.trends': 'Which trends currently have potential?',
  'admin.ai.question.sharpen': 'How can I sharpen my niche?',

  'admin.ai.rec.bestCombination.title': '🏆 Best Combination (2 Presets)',
  'admin.ai.rec.bestCombination.desc': 'Critical but constructive, with concrete action steps',
  'admin.ai.rec.bestCombination.useCase': 'Recommended for most analyses',

  'admin.ai.rec.balancedThree.title': '⚖️ Balanced (3 Presets)',
  'admin.ai.rec.balancedThree.desc': 'Professional, realistic and investor-friendly',
  'admin.ai.rec.balancedThree.useCase': 'For comprehensive business analyses',

  'admin.ai.rec.creativeDriven.title': '💡 Creative & Motivating (2 Presets)',
  'admin.ai.rec.creativeDriven.desc': 'Inspiring with practical implementation tips',
  'admin.ai.rec.creativeDriven.useCase': 'For ideation and brainstorming',

  'pdf.rating.good': 'Good',
  'pdf.rating.bad': 'Bad',
  'pdf.rating.medium': 'Medium',
  'pdf.header.subtitle': 'Analysis View',
  'pdf.footer.tagline': 'AI-Powered Niche Validation',
  'pdf.footer.page': 'Page',
  'pdf.benchmark.title': 'INDUSTRY BENCHMARK',
  'pdf.benchmark.yourScore': 'Your Score',
  'pdf.benchmark.top10': 'Top 10%: 85+',
  'pdf.marketAnalysis.title': 'MARKET ANALYSIS',
  'pdf.summary.title': 'SUMMARY',
  'pdf.structuredSummary.verdict': 'VERDICT',
  'pdf.disclaimer.body': 'This report was generated by an AI model and is intended for informational purposes only. It does not constitute financial, legal, tax, or investment advice. Market data, ratings, and projections are AI-generated estimates and may be incomplete or inaccurate. Please verify all information independently and consult qualified professionals before making any business or investment decisions. IdeaVerdict assumes no liability for actions taken based on this report.',
  'pdf.disclaimer.title': 'IMPORTANT NOTICE',
  'pdf.closing.title': 'Generated by IdeaVerdict',
  'pdf.closing.subtitle': 'AI-Powered Niche Validation  |  Comprehensive Market Intelligence',
  'history.swot.title': 'SWOT Analysis',
  'history.swot.strengths': 'Strengths',
  'history.swot.weaknesses': 'Weaknesses',
  'history.swot.opportunities': 'Opportunities',
  'history.swot.risks': 'Risks',
  'history.sections.recommendations': 'Recommendations',
  'history.sections.marketAnalysis': 'Competitive Analysis',
  'history.sections.microAngles': 'Micro-Niche Angles',
  'history.sections.improvements': 'Improvement Suggestions',
  'history.sections.alternatives': 'Alternative Niches',
  'history.sections.structuredSummary': 'Structured Summary (Builder)',
  'history.structuredSummary.strengths': 'Top Strengths',
  'history.structuredSummary.risks': 'Top Risks',
  'history.structuredSummary.actions': 'Next Steps',
  'history.sections.developerBriefing': 'Developer Briefing (Builder)',
  'history.sections.conversation': 'Conversation History',
  'history.conversation.user': 'User',
  'history.conversation.assistant': 'IdeaVerdict',
  'history.conversation.structuredResult': 'Structured Result',
  'admin.tabs.usage': 'Usage',
  'admin.usage.title': 'AI Usage & Cost Analysis',
  'admin.usage.refresh': 'Refresh data',
  'admin.usage.requests': 'Requests',
  'admin.usage.users': 'Users',
  'admin.usage.totalTokens': 'Total Tokens',
  'admin.usage.apiCosts': 'API Costs',
  'admin.usage.revenue': 'Revenue',
  'admin.usage.margin': 'Margin',
  'admin.usage.byModel': 'By Model',
  'admin.usage.allModels': 'All Models',
  'admin.usage.searchEmail': 'Search by email address...',
  'admin.usage.perPage': 'Per page:',
  'admin.usage.loading': 'Loading usage data...',
  'admin.usage.noEntries': 'No entries found for current filters.',
  'admin.usage.time': 'Time',
  'admin.usage.user': 'User',
  'admin.usage.model': 'Model',
  'admin.usage.credits': 'Credits',
  'admin.usage.tokens': 'Tokens',
  'admin.usage.duration': 'Duration',
  'admin.usage.details': 'Details',
  'admin.usage.showing': 'Showing',
  'admin.usage.of': 'of',
  'admin.usage.entries': 'entries',
  'admin.usage.firstPage': 'First Page',
  'admin.usage.prevPage': 'Previous',
  'admin.usage.page': 'Page',
  'admin.usage.nextPage': 'Next',
  'admin.usage.lastPage': 'Last Page',
  'admin.usage.requestDetails': 'Request Details',
  'admin.usage.close': 'Close',
  'admin.usage.loadingDetails': 'Loading details...',
  'admin.usage.inputTokens': 'Input Tokens',
  'admin.usage.outputTokens': 'Output Tokens',
  'admin.usage.providerCost': 'Provider Cost',
  'admin.usage.providerBreakdown': 'Provider Breakdown',
  'admin.usage.fullResponseData': 'Full Response Data',
  'admin.usage.entryNotFound': 'This entry could not be loaded.',
  'admin.usage.today': 'Today',
  'admin.usage.last7d': 'Last 7 Days',
  'admin.usage.last30d': 'Last 30 Days',
  'admin.usage.allTime': 'All Time',
  'admin.ai.fallbackModel': 'Fallback Model',
  'admin.ai.systemPrompts': 'System Prompts',
  'admin.ai.fallbackModelDesc': 'Used when the primary model fails or returns invalid output',
  'admin.ai.systemPromptsDesc': 'Read-only view of what each model receives as instructions',
  'admin.ai.provider': 'Provider',
  'admin.ai.modelId': 'Model ID',
  'admin.ai.maxTokens': 'Max Tokens',
  'admin.ai.temperature': 'Temperature',
  'admin.ai.thinkingBudget': 'Thinking Budget',
  'admin.ai.supportsThinking': 'Supports Thinking',
  'admin.ai.displayName': 'Display Name',
  'admin.ai.precise': 'Precise',
  'admin.ai.creativeTemp': 'Creative',

  // Header (dashboard top bar)
  'header.openMenu': 'Open menu',
  'header.home': 'Home',
  'header.notifications': 'Notifications',
  'header.settings': 'Settings',
  'header.profile': 'Profile',

  // Sidebar
  'sidebar.collapse': 'Collapse sidebar',
  'sidebar.expand': 'Expand sidebar',
  'sidebar.close': 'Close menu',
  'sidebar.plan': 'Plan',
  'sidebar.backToWebsite': 'Back to website',

  // Legal — Imprint (auto-added)
  'legal.imprint.title': 'Imprint',
  'legal.imprint.company': 'Scherbius Technology',
  'legal.imprint.location': 'Dubai, United Arab Emirates (UAE)',
  'legal.imprint.seatLabel': 'Registered office',
  'legal.imprint.seatBody': 'Dubai, United Arab Emirates',
  'legal.imprint.contactLabel': 'Contact',
  'legal.imprint.contactBody': 'Contact details are provided at the sole discretion of Scherbius Technology.',
  'legal.imprint.representationLabel': 'Legal representation',
  'legal.imprint.representationBody': 'Scherbius Technology is represented by its legal representatives in accordance with the laws of the United Arab Emirates.',
  'legal.imprint.contentLiabilityLabel': 'Liability for content',
  'legal.imprint.contentLiabilityBody': 'The contents of this website have been created with the greatest possible care.\nHowever, Scherbius Technology assumes no liability for the accuracy, completeness or timeliness of the content.',
  'legal.imprint.linksLiabilityLabel': 'Liability for external links',
  'legal.imprint.linksLiabilityBody': 'This website may contain links to external third-party websites whose content we have no control over.\nNo liability is assumed for these external contents.',
  'legal.imprint.lawLabel': 'Applicable law',
  'legal.imprint.lawBody': 'The laws of the United Arab Emirates apply exclusively.\nPlace of jurisdiction is Dubai, UAE.',

  // Overview page (auto-added)
  'overview.greeting': 'Welcome back',
  'overview.greetingSub': 'Here\'s what\'s happening on your verdict desk.',
  'overview.heroCta': 'New verdict',
  'overview.currentPlan': 'Current plan',
  'overview.creditsLabel': 'credits',
  'overview.usedThisCycle': 'Used this cycle',
  'overview.resetsOn': 'Resets',
  'overview.unlimitedTitle': 'Unlimited',
  'overview.builderPerk': 'You have full Builder access — no caps.',
  'overview.runOne': 'Run a verdict',
  'overview.lastVerdicts': 'Your last 5 verdicts',
  'overview.noActivity': 'No verdicts yet — start your first analysis',
  'overview.tipTitle': 'Tip',
  'overview.tipBody': 'Run an idea through two languages — if the verdict softens, your assumptions are local, not universal.',
  'onboard.skip': "Skip",
  'onboard.cta.next': "Next",
  'onboard.cta.start': "Get started",
  'onboard.s1.title': "Welcome to IdeaVerdict",
  'onboard.s1.body': "An AI verdict on your business idea — before you build.",
  'onboard.s2.title': "Brutally honest verdicts",
  'onboard.s2.body': "No hype, no flattery. Real market data, real competitors, real risks.",
  'onboard.s3.title': "Builder Reports as PDFs",
  'onboard.s3.body': "Generate 25–75 page reports with full architecture, financials and go-to-market strategy.",
  'onboard.s4.title': "Ready when you are",
  'onboard.s4.body': "Sign up and get your first verdict in under a minute.",
  'builderReport.title': "Building your Builder Report",
  'builderReport.subtitle': "Comprehensive analysis + developer briefing — downloads as PDF when ready.",
  'builderReport.idea': "Your idea",
  'builderReport.ideaPlaceholder': "Describe your business idea (or leave blank to use the last idea you discussed)…",
  'builderReport.cta': "Generate Report",
  'builderReport.credits': "credits",
  'builderReport.deductedNow': "Deducted on success",
  'builderReport.dontClose': "Please don't close this window — generation can take 30-90 seconds.",
  'builderReport.done': "PDF downloaded — check your downloads folder.",
  'builderReport.failed': "Generation failed",
  'builderReport.close': "Close",
  'builderReport.cancel': "Cancel",
  'builderReport.running': "Generating…",
  'builderReport.retry': "Try again",
  'builderReport.unknownError': "Generation failed. Your credits should be refunded.",
  'builderReport.signInRequired': "You must be signed in to generate a report.",
  'builderReport.ideaRequired': "Please describe your idea so the AI has something to analyze.",
  'builderReport.fromChat': "From your current conversation",
  'builderReport.noIdeaDetected': "Using the idea we have been discussing.",
  'builderReport.contextHint': "The AI will use everything from this chat — no new idea will be invented.",
  'builderReport.step.core': "Generating core analysis",
  'builderReport.step.market': "Adding extended market analysis",
  'builderReport.step.tech': "Adding technical architecture",
  'builderReport.step.financials': "Adding financial models",
  'builderReport.step.compet': "Adding competitive intelligence",
  'builderReport.step.gtm': "Adding go-to-market strategy",
  'builderReport.step.deepdive': "Adding industry deep-dive",
  'builderReport.step.pdf': "Compiling the PDF…",
  'briefing.title': "Building your Developer Briefing",
  'briefing.subtitle': "11-section technical briefing — downloads as PDF when ready.",
  'briefing.ideaPlaceholder': "Describe your business idea (or leave blank to use the last idea you discussed)…",
  'briefing.cta': "Generate Briefing",
  'briefing.step.core': "Generating developer briefing",
  'briefing.step.pdf': "Compiling the PDF…",
  'pricing.gold.name': "Gold",
  'pricing.gold.description': "More credits + 50-page reports",
  'pricing.gold.credits': "12,500 Credits per month",
  'pricing.platinum.name': "Platinum",
  'pricing.platinum.description': "Maximum tier + 75-page reports",
  'pricing.platinum.credits': "15,000 Credits per month",
  'trial.creditsLow': "Only {{count}} Credits left!",
  'trial.upgradeNow': "Upgrade now",
  'trial.upgradeNowArrow': "Upgrade now →",
  'trial.creditsExhausted': "Credits exhausted",
  'trial.upgradeForUnlimited': "Upgrade for unlimited use",
  'trial.noCreditsPlaceholder': "No credits left…",
  'hero.badgeHonest': "Honest, unbiased AI",
  'hero.badge60sec': "Verdict in 60 seconds",
  'hero.badge20Lang': "20+ languages",
  'hero.widget.label': "Idea Verdict",
  'hero.widget.passed': "PASSED",
  'hero.widget.demoIdea': "AI tutor for medical students",
  'hero.widget.market': "Market",
  'hero.widget.demand': "Demand",
  'hero.widget.competition': "Competition",
  'hero.widget.verdictReady': "Verdict ready · 47 sec",
  'hero.widget.riskFlagged': "Risk flagged",
  'hero.widget.crowdedMarket': "Crowded market · 4 incumbents",
  'hero.widget.suggestedPivot': "Suggested pivot",
  'hero.widget.nicheBySpecialty': "Niche by specialty",
  'hero.widget.feasibilityGain': "+38% feasibility",
  'hero.widget.analysisDone': "Analysis done",
  'hero.widget.metrics56': "5 of 6 metrics",
  'hero.stats.verdictSpeed': "Verdict speed",
  'cta.badge': "Verdict in 60 seconds",
  'cta.subtitleEnd': "without guessing.",
  'cta.signinPrompt': "Already have an account? Sign in",
  'cta.trustTrial': "7-day free trial",
  'cta.trustNoCard': "No card required",
  'cta.trustCancel': "Cancel anytime",
  'footer.themeLabel': "Theme:",
  'footer.lightMode': "Light Mode",
  'footer.darkMode': "Dark Mode",
  'footer.sectionProduct': "Product",
  'footer.sectionLegal': "Legal",
  'nav.switchLight': "Switch to Light Mode",
  'nav.switchDark': "Switch to Dark Mode",
  'features.badge': "Why IdeaVerdict",
  'features.mainFeatureLabel': "Headline",
  'chatError.planRestriction': "This feature requires a higher plan.",
  'chatError.creditDeduction': "Payment processing failed. Please try again.",
  'chatError.aiService': "AI service is temporarily unavailable. Your credits were not charged. Please try again.",
  'chatError.parseError': "An unexpected response format was received. Please try again.",
  'chatError.sessionExpired': "Your session expired. Please sign in again.",
  'chatError.timeout': "The request took too long. Please try again.",
  'chatError.generic': "Failed to get response. Please try again.",
  'faq.badge': "FAQ",
  'trial.lowCredits': "Only {credits} credits left!",
  'trial.outOfCredits': "Out of credits",
  'trial.outOfCreditsDesc': "Upgrade to keep getting verdicts.",
  'trial.viewPlans': "View plans",
  'trial.tryDemo': "Try the demo",
  'hero.widget.crowded': "Crowded market · 4 incumbents",
  'hero.widget.nicheBySpec': "Niche by specialty",
  'hero.widget.feasibilityUp': "+38% feasibility",
  'hero.widget.fiveOfSix': "5 of 6 metrics",
  'builderReport.modalTitle': "Builder Report",
  'builderReport.modalSubtitle': "Generate a comprehensive PDF for your idea",
  'builderReport.formatLabel': "Report format",
  'builderReport.formatStandard': "Standard report",
  'builderReport.formatExec': "Executive summary",
  'builderReport.toneLabel': "Tone",
  'builderReport.toneProfessional': "Professional",
  'builderReport.toneCasual': "Casual",
  'builderReport.toneTechnical': "Technical",
  'builderReport.sectionsLabel': "Sections to include",
  'builderReport.sectionMarket': "Market analysis",
  'builderReport.sectionCompetition': "Competitive landscape",
  'builderReport.sectionFinancial': "Financial model",
  'builderReport.sectionArchitecture': "Technical architecture",
  'builderReport.sectionGTM': "Go-to-market plan",
  'builderReport.sectionRisks': "Risk register",
  'builderReport.sectionRoadmap': "Product roadmap",
  'builderReport.sectionTeam': "Team & hiring plan",
  'builderReport.actionGenerate': "Generate report",
  'builderReport.actionCancel': "Cancel",
  'builderReport.actionDownload': "Download PDF",
  'builderReport.statusGenerating': "Generating your report…",
  'builderReport.statusComplete': "Report ready",
  'builderReport.statusError': "Something went wrong. Try again.",
  'builderReport.creditsRequired': "This will use {credits} credits.",
  'builderReport.pageCount': "{pages} pages",
  'builderReport.tip1': "Tip: be specific about your target customer for sharper analysis.",
  'builderReport.tip2': "Tip: include early revenue numbers if you have them.",
  'builderReport.tip3': "Tip: mention your tech preferences if any.",
  'builderReport.errorNotEnough': "You don't have enough credits for this report.",
  'builderReport.errorUpgrade': "Upgrade to a higher plan",
  'builderReport.errorTryStandard': "Try the Standard report instead",
  'builderReport.success': "Your Builder Report is ready.",
  'builderReport.previewBadge': "Preview",
  'builderReport.previewNote': "This is a preview. Generate the full PDF to see all sections.",
  'builderReport.includesLabel': "Includes",
  'builderReport.pagesIncluded': "{pages} pages of analysis",
  'builderReport.estimatedTime': "Estimated time: {minutes} min",
  'builderReport.fullReport': "Full report",
  'builderReport.execSummary': "Executive summary",
  'pricing.builder.report': "25-page Builder Report",
  'pricing.gold.report': "50-page Builder Report",
  'pricing.platinum.report': "75-page Builder Report",
  'auth.bestValue': "Best Value",
  'auth.elite': "Elite",
  'builderReport.friendlyError': "We couldn't finish your report this time. Your credits weren't charged — please try again in a moment.",
  'builderReport.persistHint': "If this keeps happening, contact support@ideaverdict.ai.",
};
